import React from 'react';
import PropTypes from 'prop-types';
import reportResources from './reportResources';
import ReportResources from '../Resources';
import ReportHeading from '../ReportHeading';

import OperationalReportCard from './OperationalReportCard';
import OperationalReportsStyles from './OperationalReports.module.css';
import mainStyles from '../MainContainer.module.css';

import Accordions from '../Accordion/Accordions';
import tabDetails from '../Navigation/tabDetails';
import commonStrings from '../../resources/commonStrings';

const reportShape = PropTypes.shape({ identifier: PropTypes.string.isRequired });

const propTypes = {
  reportDetails: PropTypes.arrayOf(reportShape).isRequired,
  accordionDetails: PropTypes.instanceOf(Map).isRequired,
  onAccordionStateChange: PropTypes.func.isRequired,
  sessionToken: PropTypes.object.isRequired,
};

function OperationalReports({ reportDetails, accordionDetails, onAccordionStateChange, sessionToken }) {
  // group the reports under the appropriate grouping header
  const groupedReports = reportDetails.reduce((acc, reportDetail) => {
    if (!acc.get(reportDetail.grouping)) {
      acc.set(reportDetail.grouping, []);
    }
    acc.get(reportDetail.grouping).push(reportDetail);
    return acc;
  }, new Map());

  const renderOperationalReportGroup = (groupTitle, groupReportCards) => {
    const reportCards = groupReportCards.map((reportCard) => (
      <OperationalReportCard key={reportCard.identifier} cardDetails={reportCard} />
    ));

    const groupTitleClasses = `${OperationalReportsStyles['group-title']} nwea-ds-v1-typography-label`;
    const titleDisplayText = `${groupTitle.toUpperCase()}:`;

    return (
      <div key={groupTitle} className={OperationalReportsStyles['grouping']}>
        <h3 className={groupTitleClasses}>{titleDisplayText}</h3>
        {reportCards}
      </div>
    );
  };

  const operationalReportGroups = [];
  groupedReports.forEach((value, key) => {
    operationalReportGroups.push(renderOperationalReportGroup(key, value));
  });

  return (
    // Note section and aside are rendered in this order then reversed via css so that tab ordering happens as desired
    <React.Fragment>
      <h1 className={mainStyles['page-title']}>{commonStrings.operational.pageTitle}</h1>
      <ReportHeading />
      <aside className={`${OperationalReportsStyles['column']} ${OperationalReportsStyles['width-3']}`}>
        <Accordions
          accordions={accordionDetails}
          containingTab={tabDetails.operationalReports.urlEndPoint}
          onAccordionStateChange={onAccordionStateChange}
          sessionToken={sessionToken}
        />
        <ReportResources resources={reportResources} />
      </aside>
      <section className={`${OperationalReportsStyles['column']} ${OperationalReportsStyles['width-9']}`}>
        {operationalReportGroups}
        <footer className={mainStyles['confidentiality-statement']}>{commonStrings.pageFooter}</footer>
      </section>
    </React.Fragment>
  );
}

OperationalReports.propTypes = propTypes;

export default OperationalReports;
